import { isAdmin } from "./helpers";
const adminPermissions = {
    admin: {
        index: ({ user }) => isAdmin(user),
        branches: ({ user }) => isAdmin(user),
        customers: ({ user }) => isAdmin(user),
        phoneNos: ({ user }) => isAdmin(user),
    },
};
export default adminPermissions;
